<template>
  <div>
    <pre v-if="debug">{{ filter }}</pre>
    <div class="filter">
      <div class="filter__labels mb-3">
        <span class="rhg-text-normal rhg-text-md">{{ translate('rdFilterRates') }}</span>
        <span
          v-if="filter.hasAnySelection(isFirstRoom)"
          class="rhg-text-normal rhg-text-md filter__clear"
          @click="$emit('clear')"
        >
          {{ translate('rdClearAllFilters') }}
        </span>
      </div>
      <div class="filter__options">
        <FilterOptionComponent
          v-for="(option, index) in filterOptions"
          :key="index"
          :option="option"
          :showNumberOfMatches="showNumberOfMatches"
          @select="$emit('select', $event)"
          @unselect="$emit('unselect', $event)"
          :selectedRoomCode="selectedRoomCode"
          :numberOfRoomsLeftByRoomId="numberOfRoomsLeftByRoomId"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FilterOptionComponent from './FilterOptionComponent'
import Filter from '../../domain/Filter'
import FilterOption from '../../domain/FilterOption'

export default {
  name: 'FilterComponent',
  components: { FilterOptionComponent },
  props: {
    filter: {
      type: Filter
    },
    isFirstRoom: {
      type: Boolean,
      defaultValue: false
    },
    showNumberOfMatches: {
      type: Boolean,
      defaultValue: false
    },
    showBreakfast: {
      type: Boolean,
      defaultValue: false
    },
    selectedRoomCode: {
      type: String
    },
    numberOfRoomsLeftByRoomId: {
      type: Array
    }
  },
  computed: {
    debug() {
      return localStorage.getItem('@debug/multi-room/filters') === 'true'
    },
    filterOptions() {
      if (this.showBreakfast) {
        return this.filter.options.filter(option => option.code !== FilterOption.MULTIROOM_ID)
      } else {
        return this.filter.options.filter(
          option =>
            option.code !== FilterOption.MULTIROOM_ID && option.code !== FilterOption.BREAKFAST
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">
.filter {
  display: flex;
  flex-direction: column;

  &__labels {
    display: flex;
    justify-content: space-between;
  }

  &__options {
    display: flex;
  }

  &__title {
    font-weight: bold;
  }

  &__clear {
    cursor: pointer;
    font-weight: bold;
    text-decoration: underline;
    color: #c41c0f;
  }
}

html[dir='rtl'] {
  .filter {
    &__title {
      margin-right: 0.4rem;
    }
  }
}
</style>
